import { NotebookPen, Library, GraduationCap } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

export const koreanBottomNav: BottomNavItem[] = [
  { id: 'capture', label: 'Capture', icon: NotebookPen, href: '/apps/korean' },
  { id: 'words', label: 'Words', icon: Library, href: '/apps/korean/words' },
  { id: 'study', label: 'Study', icon: GraduationCap, href: '/apps/korean/study' },
]
